import http from "./http_common";

class CommonService{
    StatesList(payload){
      if(payload){
        var queryString = Object.keys(payload).map((key) => key + "=" + payload[key]).join("&");
        return http.get(`/stateMaster/list/filter?${queryString}`);
      }
     }

      CityList(payload){
        var queryString = Object.keys(payload).map((key) => key + "=" + payload[key]).join("&");
        return http.get(`/cityMaster/list/filter?${queryString}`);
      }
    
     CountriesList(payload){
      var queryString = Object.keys(payload).map((key) => key + "=" + payload[key]).join("&");
        return http.get(`/country_Master/list/filter?${queryString}`);
     }

     RelationList(payload){
      var queryString = Object.keys(payload).map((key) => key + "=" + payload[key]).join("&");
      return http.get(`/RelationMaster/list/filter?${queryString}`);
     }

     customerQuery(payload){
      return http.post('/SubscriptionPlanType/save',payload);
     }
}

export default new CommonService();